export default "__VITE_PUBLIC_ASSET__8447aa54__"